import { useState } from 'react';
import { BsArrowsFullscreen, BsX } from 'react-icons/bs';

function FilterItem({ image, name, price, heading }) {
    const [lightboxOpen, setLightboxOpen] = useState(false);

    return (
        <>
            <div className="col-xl-3 col-md-6 grid-item bedroom">
                <div className="single-cause-item">
                    <div className="cause-bg bg-cover" style={{ backgroundImage: `url(${image})` }}>
                        <button className="icon" onClick={() => setLightboxOpen(true)}>
                            <BsArrowsFullscreen />
                        </button>
                    </div>
                    <div className="cause-content">
                    </div>
                </div>
            </div>

            {lightboxOpen && (
                <div
                    className="lightbox-overlay"
                    onClick={() => setLightboxOpen(false)}
                    style={{
                        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        zIndex: 9999,
                    }}
                >
                    <button
                        onClick={() => setLightboxOpen(false)}
                        style={{
                            position: 'absolute', top: 16, right: 16,
                            background: 'none', border: 'none', color: '#fff',
                            fontSize: 32, cursor: 'pointer', lineHeight: 1,
                        }}
                    >
                        <BsX />
                    </button>
                    <img
                        src={image}
                        alt={name}
                        onClick={(e) => e.stopPropagation()}
                        style={{ maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain', borderRadius: 4 }}
                    />
                </div>
            )}
        </>
    );
}

export default FilterItem;
